export default "__VITE_ASSET__00debccd__"